import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import querystring from 'querystring';
import { I18n } from 'react-redux-i18n';

import Frame from './frame';
import Spinner from '../common/spinner';
import LoginForm from './loginForm';
import RecordResultMessage from '../common/recordResult';

import { authenticate, mockAuthenticate, clearMfa } from '../../modules/session';
import { clearRecordMessages } from '../../modules/authentication';
import { getSafeReturnPath } from '../../helpers/returnUrl';

class Login extends Component {
  componentDidMount() {
    // Clear any stale MFA state when landing on login page
    this.props.clearMfa();
  }

  clearMessages = () => {
    this.props.clearRecordMessages('updatePasswordRecord');
  };

  render() {
    if (this.props.session?.processing) {
      return <Spinner />;
    }

    // If MFA is pending, redirect to MFA verification page
    if (this.props.session?.mfaPending && this.props.session?.pendingSessionToken) {
      const returnParam = new URLSearchParams(window.location.search).get('return');
      const mfaUrl = returnParam
        ? `/verify-mfa?return=${encodeURIComponent(returnParam)}`
        : '/verify-mfa';
      return <Navigate to={mfaUrl} replace />;
    }

    // If authenticated, then redirect to home or return url param.
    // `key` is `undefined` (not null) in the initial/MFA-pending state, so
    // guard against both — otherwise back-to-login / MFA timeout would skip
    // the form and redirect away. Matches mfaVerification.jsx.
    if (this.props.session?.key !== null && this.props.session?.key !== undefined) {
      if (
        window &&
        window.location.search &&
        window.location.search.length > 1
      ) {
        const q = querystring.decode(window.location.search.slice(1));
        const returnPath = getSafeReturnPath(q.return);
        if (returnPath) {
          return <Navigate to={returnPath} replace />;
        }
      }

      return <Navigate to="/" replace />;
    }

    // Render Login Panel
    return (
      <Frame error={this.props.error}>
        <RecordResultMessage
          record={this.props.updatePasswordRecord}
          onDismiss={this.clearMessages}
        />
        <LoginForm header={I18n.t('authentication.login.heading')} />
      </Frame >
    );
  }
}

const mapStateToProps = ({ general, session, authentication }) => {
  return {
    error:
      general.errorsTimed && general.errorsTimed.length > 0
        ? general.errorsTimed[0]
        : null,
    updatePasswordRecord: authentication.updatePasswordRecord,
    session: session
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      authenticate,
      mockAuthenticate,
      clearRecordMessages,
      clearMfa
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
